import { render } from "./humanityCourseDetail.vue?vue&type=template&id=4d98787a&scoped=true"
import script from "./humanityCourseDetail.vue?vue&type=script&lang=js"
export * from "./humanityCourseDetail.vue?vue&type=script&lang=js"

import "./humanityCourseDetail.vue?vue&type=style&index=0&id=4d98787a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d98787a"]])

export default __exports__